import {
  BadgeCheck,
  Check,
  CircleAlert,
  CircleCheckBig,
  Copy,
  Eye,
  FileCode,
  Upload,
  X,
} from "lucide-react";
import React, { useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import ProgressBar from "../../../global/ProgressBar";
import MyCard5 from "../../../tools/MyCard5";
import JsonPreview from "../../../global/JsonPreview";
import MyCard from "../../../tools/MyCard";
import PageTitle from "../../../global/PageTitle";

export default function Deeplink() {
  const fileInputRef = useRef(null);

  const [isUploaded, setIsUploaded] = useState(true);
  const [hasJsonFile, setHasJsonFile] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [showPreview, setShowPreview] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [jsonPreview, setJsonPreview] = useState("");
  const [jsonError, setJsonError] = useState(null);
  const [isJsonValid, setIsJsonValid] = useState(false);
  const [value, setValue] = useState("mangocash.com");

const copyText = () => {
  navigator.clipboard.writeText(value);
  toast("copied")
};

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "application/json") {
      toast("Only .json files are allowed");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      toast("File size must be less than 10MB");
      return;
    }

    setHasJsonFile(true); // <-- Mark as uploaded
    setFileSize(formatFileSize(file.size)); // MB with 2 decimals
    setFileName(file.name); // <-- Store file name
    setShowPreview(true); //<--show preview

    const reader = new FileReader();
    reader.onload = () => {
      //   setHtmlPreview(reader.result); // Set HTML preview
    };
    reader.readAsText(file);

    console.log("Selected file:", file);

    reader.onload = () => {
      const jsonText = reader.result;

      // show original content in preview box
      // setJsonPreview(JSON.stringify(JSON.parse(jsonText), null, 1));
      setJsonPreview(jsonText);

      if (!jsonText.trim()) {
        setJsonError("JSON cannot be empty");
        setIsJsonValid(false);
        return;
      }

      try {
        JSON.parse(jsonText);
        setJsonError(null);
        setIsJsonValid(true);
      } catch (error) {
        setJsonError("Invalid JSON format");
        toast("Invalid JSON format");
        setIsJsonValid(false);

        //invalid
        setHasJsonFile(false); // <-- Mark as uploaded

        setShowPreview(false); //<--show preview
      }
    };
  };

  function formatFileSize(bytes) {
    if (bytes < 1024) return bytes + " Bytes";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + " KB";
    if (bytes < 1024 * 1024 * 1024)
      return (bytes / 1024 / 1024).toFixed(2) + " MB";
    return (bytes / 1024 / 1024 / 1024).toFixed(2) + " GB";
  }

  function toNew() {
    setHasJsonFile(false);
    setFileName("");
    setFileSize("");
    // setPreviewMode("desktop");
    setShowPreview(false);
  }
  let alreadySaved = true;

  return (
    <div className="space-y-2 px-10 pt-4">
      <Toaster />
      <PageTitle
     
               title="Deeplink Configuration"
               subtitle="Upload your deeplink JSON configuration file to set up deep linking for your app"
             />
      {/* no deeplink card */}
      {isUploaded && (
        <div className="w-full space-x-2  mt-4 p-4 flex items-center justify-start bg-amber-50 dark:bg-amber-950/20 border-1 border-amber-400/30 rounded-lg">
          <CircleAlert className="w-8 h-8 p-1 text-amber-600 bg-amber-400/20 rounded-md " />
          <div className="flex flex-col justify-center">
            <span className="text-sm text-amber-800 dark:text-amber-400 font-semibold">
              No Deeplink Configuration Set
            </span>
            <span className="text-[12px] text-amber-800 dark:text-amber-400 font-normal ">
              Upload a JSON file below to set up your deeplink configuration.
            </span>
          </div>
        </div>
      )}

      {/* already saved */}
      {alreadySaved && (
        <MyCard5
          icon={CircleCheckBig}
          color="green"
          title="Deeplink Configuration Already Saved"
          subtitle="You have a deeplink configuration already uploaded. You can update it below."
        />
      )}

      {/* mid section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 space-x-4 mt-4">
        <div className="md:col-span-1 flex flex-col  w-full">
          {/* upload card */}
          {!hasJsonFile && (
            <div
              className="  p-5
         bg-white dark:bg-slate-600/30 
         rounded-lg border-1 border-gray-300
         shadow-sm relative"
            >
              <div
                className=" py-8 flex flex-col 
          justify-center items-center 
          rounded-lg 
          cursor-pointer hover:bg-gray-200/40
          dark:hover:bg-gray-400/20
          border-dotted border-2 border-gray-300 hover:border-gray-700 hover:dark:border-slate-100"
              >
                <Upload className="w-14 h-14 p-3 rounded-full bg-gray-400/20 dark:bg-gray-500 text-slate-400 dark:text-slate-300" />
                <span className="text-sm text-slate-800 dark:text-slate-100 font-semibold mt-3">
                  Drag & drop your JSON file here
                </span>
                <span className="text-xs mt-1 text-slate-800 dark:text-slate-100 font-normal ">
                  or click to browse
                </span>
                <div className="flex items-center justify-center mt-2 space-x-2">
                  <span className="text-xs mt-1 rounded-full m px-2 py-[2px] bg-slate-300/40 text-slate-800 dark:text-slate-100 font-normal">
                    .json files only
                  </span>
                  <span className="text-xs mt-1 rounded-full m px-2 py-[2px] bg-slate-300/40 text-slate-800 dark:text-slate-100 font-normal">
                    Max 10MB
                  </span>
                </div>

                {/* Hidden file input */}
                <input
                  type="file"
                  accept=".json"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="absolute inset-0 w-full h-full opacity-0  bg-amber-500 cursor-pointer"
                />
              </div>
            </div>
          )}

          {/* uploaded card */}
          {hasJsonFile && (
            <div className="w-full  rounded-lg border-1 border-gray-300/60 bg-white p-4">
              <div className="w-full h-full rounded-lg border-1 border-gray-300/60 bg-gray-200/30">
                {/* Card Header */}
                <div className="flex items-center justify-between py-4 px-4 border-b-1 border-gray-300/60">
                  <div className="flex items-start justify-start space-x-2 w-full">
                    {/* icon */}
                    <div class="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center flex-shrink-0">
                      <FileCode className="text-white " />
                    </div>

                    <div className="flex flex-col  space-y-1 w-full pr-10 ">
                      <span className="text-sm font-bold  text-slate-900">
                        {fileName}
                      </span>
                      <span className="text-[11px] font-normal font-sans text-slate-900">
                        {fileSize + " • HTML File"}
                      </span>
                      {isUploading && (
                        <div className="w-full mt-1">
                          <ProgressBar progressPercentage={20} h={1} />
                          <span className="text-[11px] text-slate-500 ">
                            Uploading...
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col itemx-end justify-end">
                    <X
                      onClick={() => toNew()}
                      className="w-7 h-7 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-500/16 cursor-pointer p-1 "
                    />
                    {!isUploaded && (
                      <span className=" text-[10px] rounded-full text-green-700 bg-green-300/20 border-1 border-green-800 px-2 py-1">
                        Uploaded
                      </span>
                    )}
                  </div>
                </div>
                {/* ------------------------------------- */}
                {/* actions  */}
                <div
                  onClick={() => setIsUploaded(true)}
                  className="flex items-center m-4 justify-center bg-blue-600 border-1 hover:bg-blue-500 cursor-pointer border-gray-300/60 
            py-3 rounded-md space-x-1"
                >
                  <Upload className="w-4 h-4 text-white" />
                  <span className="text-white text-sm font-medium ">
                    Upload Config
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* preview card */}
          {hasJsonFile && (
            <>
              <JsonPreview jsonError={jsonError} jsonPreview={jsonPreview} />
            </>
          )}
          {alreadySaved && (
            <JsonPreview
              jsonError={jsonError}
              jsonPreview={jsonPreview}
              isCurrentFile={true}
            />
          )}
        </div>

        {/* tips Card */}
        <div className="sm:col-span-1 flex flex-col space-y-4">
          <MyCard className="p-4 flex flex-col relative">
            {/* domain name */}
            <label className="text-xs font-sans font-medium  text-slate-900 dark:text-slate-200 tracking-wide">
             Domain 
            </label>

            {/* Input */}
            <input
              type="text"
              name="companyName"
              value="mangocash.moon"

              onChange={(e) => setValue(e.target.value)}
              placeholder="Your Company Inc."
              className="w-full  px-2 py-2 rounded-md 
            mt-2 text-slate-900 dark:text-white text-xs placeholder-slate-500 
            dark:placeholder:text-slate-400
             readOnly
            focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
            border-[2px] border-slate-200 dark:border-slate-300/30"
            />
           <Copy onClick={copyText} className=" cursor-pointer text-slate-500 dark:text-white w-4 h-4 absolute right-8 top-12"/>
          </MyCard>
          <div className="   p-4 flex space-y-1 flex-col  bg-blue-400/10 rounded-lg border-1 border-blue-400">
            <h1 className="text-sm font-bold text-blue-800 dark:text-blue-200 ">
              <span class="text-lg">💡</span>
              Quick Tips
            </h1>
            <ul class="space-y-3 text-sm text-blue-800 dark:text-blue-200">
              <li class="flex items-start gap-2">
                <span class="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
                <span className="text-xs">
                  JSON file should contain valid deeplink configurations
                </span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
                <span className="text-xs">
                  Use standard JSON format with proper syntax
                </span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
                <span className="text-xs">Maximum file size is 10MB</span>
              </li>
              <li class="flex items-start gap-2">
                <span class="text-blue-600 dark:text-blue-400 mt-0.5">•</span>
                <span className="text-xs">
                  Preview updates automatically when valid JSON is detected
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
